import type { SVGProps } from 'react';

export const FaceNeutral = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="512px"
    role="img"
    viewBox="0 0 512 512"
    width="512px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'face neutral'}</title>
    <g transform="scale(1,-1) translate(0 -512)">
      <path
        d="M256 479c124 0 223-100 223-223 0-124-100-223-223-223-124 0-223 99-223 223 0 124 99 223 223 223m0 33c-141 0-256-115-256-256 0-141 115-256 256-256 141 0 256 115 256 256 0 141-115 256-256 256m-95-265c-20 0-37 16-37 36 0 21 17 37 37 37 20 0 36-16 36-37-1-22-16-36-36-36m0 55c-11 0-20-9-20-20 0-11 9-21 20-21 11 0 20 10 20 21 0 11-9 20-20 20m192-55c-20 0-37 16-37 36 0 21 17 37 37 37 20 0 36-16 36-37-1-22-16-36-36-36m0 55c-11 0-20-9-20-20 0-11 9-21 20-21 11 0 20 10 20 21 0 11-9 20-20 20m-15-169c2 0 4 6 4 10 0 3-2 9-4 9l-153 0c-2 0-4-6-4-9 0-4 2-10 4-10l153 0"
        fill={props.fill}
      />
    </g>
  </svg>
);
